import type { Notification } from '../shared/types.js';
import { isReleaseNotification } from './groupNotifications.js';

/**
 * Detail-view counterpart of {@link ./groupNotifications.ts#groupReleaseNotifications}.
 *
 * Given the notification currently selected in a detail view and the list of
 * visible (non-dismissed, non-expired) notifications, returns the full list
 * of un-dismissed release notifications — newest first — when the selection is
 * part of a stack of 2+ such releases, or `null` otherwise.
 *
 * Returning the same group the inbox row collapsed keeps detail-view content
 * and dismissal scope in sync with the inbox: clicking the stacked row
 * surfaces every release inside, and the "Dismiss all" button clears them
 * together instead of leaving older entries behind for the user to chase.
 */
export function resolveReleaseGroup(
  selected: Notification | null,
  visible: Notification[],
): Notification[] | null {
  if (!selected || selected.dismissed || !isReleaseNotification(selected)) return null;
  const releases = visible
    .filter((n) => isReleaseNotification(n) && !n.dismissed)
    .sort((a, b) => b.createdAt - a.createdAt);
  if (releases.length < 2) return null;
  if (!releases.some((r) => r.id === selected.id)) return null;
  return releases;
}
